<!--
 * @Author: your name
 * @Date: 2020-11-05 10:58:08
 * @LastEditTime: 2024-08-15 10:46:19
 * @LastEditors: gaolongxin062 gaolongxin062@163.com
 * @Description: In User Settings Edit
 * @FilePath: \weici-web\src\components\Menu.vue
-->
<template>
  <div class="menu">
    <a href="/" class="a_logo">
      <div class="logo"><img src="../assets/images/logo.png" /></div>
      <div class="com_name">
          维词
      </div>
    </a>
    <div class="nav">
      <ul class="main_menu">
        <li v-bind:class="{ cur: menu.home }">
          <router-link :to="{name: 'Teacher'}" v-bind:style="{ color: (menu.home ? '#fff':'')}">高中</router-link>
        </li>
        <li v-bind:class="{ cur: menu.junior }">
          <router-link :to="{name: 'Teachercz'}" v-bind:style="{ color: (menu.junior ? '#fff':'')}">初中</router-link>
        </li>
        <!-- <li v-bind:class="{ cur: menu.discovery }">
          <router-link :to="{name: 'Discovery'}" v-bind:style="{ color: (menu.discovery ? '#fff':'')}">发现</router-link>
        </li> -->
        <li v-bind:class="{ cur: menu.about }">
          <router-link :to="{name: 'About'}" v-bind:style="{ color: (menu.about ? '#fff':'')}">关于我们</router-link>
        </li>
<!--         <li v-bind:class="{ cur: menu.msg }">-->
<!--          <router-link :to="{name: 'Message'}" v-bind:style="{ color: (menu.msg ? '#fff':'')}">资讯</router-link>-->
<!--        </li>-->
      </ul>
      <div class="curBg"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menu: {
        home: true,
        junior: false,
        discovery: false,
        about: false,
        msg: false
      }
    }
  },
  props: ['menuName'],
  created: function () {
    this.init()
  },
  methods: {
    init () {
      switch (this.menuName) {
        case 'home':
          this.menu.home = true
          this.menu.junior = false
          this.menu.discovery = false
          this.menu.about = false
          this.menu.msg = false
          break
        case 'junior':
          this.menu.home = false
          this.menu.junior = true
          this.menu.discovery = false
          this.menu.about = false
          this.menu.msg = false
          break
        case 'discovery':
          this.menu.home = false
          this.menu.junior = false
          this.menu.discovery = true
          this.menu.about = false
          this.menu.msg = false
          break
        case 'about':
          this.menu.home = false
          this.menu.junior = false
          this.menu.discovery = false
          this.menu.about = true
          this.menu.msg = false
          break
        case 'msg':
          this.menu.home = false
          this.menu.junior = false
          this.menu.discovery = false
          this.menu.about = false
          this.menu.msg = true
          break
        default:
          break
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// Menu.vue?3c605ed0